import styled from "styled-components";

export const OrderHeaderWrapper = styled.div`
  background-color: #008395;
  border-radius: 5px 5px 0px 0px;
  margin-top: 10px;
`;

export const ListWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border-radius: 5px 5px 0px 0px;
`;

export const GridItem = styled.div`
  border-right: ${(props) => props.borderRight ?? "2px solid #767676"};
  border-left: ${(props) => props.borderLeft ?? "0px solid #767676"};
  text-align: ${(props) => props.textAlign ?? "center"};
  color: #fff;
  font-weight: ${(props) => props.fontWeight ?? "400"};
  padding: ${(props) => props.padding ?? "11px"};
  font-size: ${(props) => props.fontSize ?? "16px"};
  border-radius: ${(props) => props.radius ?? "0px 0px 0px 0px"};
  align-content: ${(props) => props.alignContent ?? "flex-start"};
`;

export const SolutionIdLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
  color: ${(props) => props.color ?? "#0A4986"};
`;

export const DivToolTip = {
  maxWidth: "300px",
  wordBreak: "break-all",
  overflowWrap: "break-word",
  display: "block",
  zIndex: 99999,
  backgroundColor: "#fff",
  color: "rgb(71, 71, 71)",
};
